import React from 'react';
import PropTypes from 'prop-types';
import TrcTables from './trcTables/TrcTables';
import { SECTION_IDS, TITLE } from '../../../../../constants/shared/CommonConstants';
import { getYearsContraction } from '../../common/gradeNavTabs';
import { getGradeTitle } from '../../../../../constants/shared/GradesConstants';
import './TrcContent.scss';

const { TEXT_READING_HISTORY } = SECTION_IDS;

const TrcContent = props => {
    const {
        selectedGradeYear: gradeYear,
        openProbeDetails,
        trcSummaryData,
        cards,
        summeryLabel,
    } = props;

    return (
        <div id={TEXT_READING_HISTORY}>
            <section className="trc-cards-section">
                <div className="header">
                    <strong>Final Reading Level: </strong>
                    {`${getGradeTitle(gradeYear.grade)} (${getYearsContraction(gradeYear.year)})`}
                </div>
                <div className="trc-cards">{cards}</div>
            </section>
            <TrcTables
                results={trcSummaryData}
                openProbeDetails={openProbeDetails}
                summeryLabel={summeryLabel}
            />
        </div>
    );
};

TrcContent.defaultProps = {
    trcSummaryData: [],
    cards: [],
    selectedGradeYear: {},
    openProbeDetails: () => {},
    summeryLabel: TITLE.SUMMER_TITLE,
};

TrcContent.propTypes = {
    trcSummaryData: PropTypes.arrayOf(PropTypes.object),
    cards: PropTypes.arrayOf(PropTypes.element),
    selectedGradeYear: PropTypes.object,
    openProbeDetails: PropTypes.func,
    summeryLabel: PropTypes.string,
};

export default TrcContent;
